// TODO: move it to theme, reduce it!!!

/** Flat styles for MUI `<GlobalStyles styles={...} />` (Emotion). */
const muiGlobalStyles = theme => ({
  // GENERAL
  '*': {
    scrollBehavior: 'smooth',

    // SCROLLBARS
    scrollbarColor: 'rgba(180, 180, 180, 0.25) transparent',
    scrollbarWidth: 'thin',
  },
  html: {
    overscrollBehaviorY: 'none',
    colorScheme: 'only light',
  },
  body: {
    overflowX: 'hidden',
    background: theme.palette.grey[100],
    color: theme.palette.text.primary,
    overscrollBehaviorY: 'none',
  },
  // Tamagui extracted CSS sets body background in prefers-color-scheme: dark and
  // stays loaded after leaving /my-progress. Keep the SPA light-only.
  '@media (prefers-color-scheme: dark)': {
    body: {
      background: `${theme.palette.grey[100]} !important`,
      color: `${theme.palette.text.primary} !important`,
    },
  },
  a: {
    textDecoration: 'none',
  },

  // INPUTS
  '.MuiOutlinedInput-root': {
    borderRadius: 0,
    background: '#fff',
  },
  '.MuiFormControl-root': {
    width: '100%',
  },
  '.MuiOutlinedInput-colorSecondary.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.primary.main,
  },
  // Chrome autofill: keep floating label shrunk + outline notched (JS may lag behind paint)
  '.MuiFormControl-root:has(.MuiOutlinedInput-input:-webkit-autofill) .MuiInputLabel-outlined': {
    transform: 'translate(14px, -9px) scale(0.75)',
    maxWidth: 'calc(133% - 32px)',
  },
  '.MuiFormControl-root:has(.MuiOutlinedInput-input:-webkit-autofill) .MuiInputLabel-sizeSmall': {
    transform: 'translate(14px, -6px) scale(0.75)',
  },
  '.MuiFormControl-root:has(.MuiOutlinedInput-input:-webkit-autofill) .MuiOutlinedInput-notchedOutline legend': {
    maxWidth: '100%',
  },
  'input[type=number]::-webkit-inner-spin-button': {
    WebkitAppearance: 'none',
    margin: 0,
  },
  'input[type=number]::-webkit-outer-spin-button': {
    WebkitAppearance: 'none',
    margin: 0,
  },

  // PAPER
  '.MuiDialog-paperWidthSm.MuiDialog-paperScrollPaper': {
    maxWidth: '800px',
  },
  '.MuiDialog-paper:not(.MuiDialog-paperFullScreen)': {
    background: '#f5f5f5',
    margin: '18px',
  },
  '.MuiDialog-paper': {
    borderRadius: 0,
    backgroundColor: '#f5f5f5',
  },

  // BUTTONS
  '.MuiButton-outlinedSecondary': {
    borderColor: '#fff',
  },
  '.MuiButton-containedSecondary': {
    color: '#fff',
  },
  // SCROLLBARS
  '*::-webkit-scrollbar': {
    width: '0.4rem',
    height: '0.4rem',
  },
  '*::-webkit-scrollbar-track': {
    WebkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
  },
  '*::-webkit-scrollbar-thumb': {
    borderRadius: 4,
    backgroundColor: 'rgba(180, 180, 180, 0.25)',
  },

  // PRINT
  '@media print': {
    body: {
      border: '1px solid white',
      height: '99%',
      pageBreakAfter: 'avoid',
      pageBreakBefore: 'avoid',
    },
    html: {
      border: '1px solid white',
      height: '99%',
      pageBreakAfter: 'avoid',
      pageBreakBefore: 'avoid',
    },
  },

  // Recaptcha hide
  '.grecaptcha-badge': {
    visibility: 'hidden !important',
  },

  // MenuLink premium tooltips
  '.MenuTooltip_premium': {
    background: theme.palette.primary.main,
  },
  '.MenuTooltipArrow_premium': {
    color: theme.palette.primary.main,
  },

  '@keyframes menuLinkPointerMove': {
    '0%': { transform: 'translateY(0%)' },
    '70%': { transform: 'translateY(35%)' },
    '100%': { transform: 'translateY(0%)' },
  },
});

export default muiGlobalStyles;
